export default [
    {
        path: "/bq-store/account/group",
        component: () => import("./List.vue"),
        name: "bq.store.account.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/account/group/create",
        component: () => import("./Create.vue"),
        name: "bq.store.account.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/account/group/:id/edit",
        component: () => import("./Edit.vue"),
        name: "bq.store.account.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
